import { render, staticRenderFns } from "./ProductImagesForm.vue?vue&type=template&id=1bd3ec12&scoped=true&"
import script from "./ProductImagesForm.vue?vue&type=script&lang=js&"
export * from "./ProductImagesForm.vue?vue&type=script&lang=js&"
import style0 from "./ProductImagesForm.vue?vue&type=style&index=0&id=1bd3ec12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd3ec12",
  null
  
)

export default component.exports